<form class="itinerary-model-content-inner" [formGroup]="visaForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Document Collection</ion-title>
    </div>
    <div class="form-container ion-padding-horizontal">

      <div class="bg-light-blue rounded my-1 p-2">
        <div class="title-container">
          <h3 class="title fs-6">Destination</h3>
        </div>

        <!-- Visa item for passenger Item -->
         <div formArrayName="data">
          <div *ngFor="let visa of visasArray().controls; let visaIndex = index" [formGroupName]="visaIndex" class="mb-3">
            <div class="bg-dark-blue rounded">
              
              <div class="row passenger-row p-1">
                <div class="col-2">
                  <div class="passenger-input">
                    <label class="label">Passenger Name</label>
                    <div>
                      <p class="value">{{visasArray().at(visaIndex).get('firstName')?.value}} {{visasArray().at(visaIndex).get('lastName')?.value}}</p>
                    </div>
                  </div>
                </div>
                <div style="width: 140px;">
                  <div class="passenger-input">
                    <label class="label">Age</label>
                    <div>
                      <p class="value">{{visasArray().at(visaIndex).get('age')?.value}}</p>
                    </div>
                  </div>
                </div>
                <div  style="width: 106px;">
                  <div class="passenger-input">
                    <label class="label">Gender</label>
                    <div>
                      <p class="value">{{visasArray().at(visaIndex).get('gender')?.value}}</p>
                    </div>
                  </div>
                </div>
                <div  style="width: 100px;">
                  <div class="passenger-input">
                    <label class="label">Nationality</label>
                    <div>
                      <p class="value">{{visasArray().at(visaIndex).get('nationality')?.value}}</p>
                    </div>
                  </div>
                </div>
                <div  style="width: 100px;">
                  <div class="passenger-input">
                    <label class="label">Visa Type</label>
                    <div>
                      <p class="value">{{visasArray().at(visaIndex).get('visaType')?.value}}</p>
                    </div>
                  </div>
                </div>
                <div  style="width: 110px;">
                  <div class="passenger-input">
                    <label class="label">Applicant Type</label>
                    <div>
                      <p class="value">{{visasArray().at(visaIndex).get('applicantType')?.value}}</p>
                    </div>
                  </div>
                </div>
                
              </div>

              <div class="row mt-2 p-1">
                <div class="col-12">
                  <app-status-progress-bar-input formControlName="status"></app-status-progress-bar-input>
                </div>
              </div>

              <div>
                <table class="table mb-0">
                  <thead class="thead-dark sticky-top">
                    <th class="options-column">
                      <div class="table-heading">
                        <p class="text mb-0">S No.</p>
                      </div>
                    </th>
                    <th class="column-width-130">
                      <div class="table-heading">
                        <p class="text mb-0">Document Name</p>
                      </div>
                    </th>
                    <th class="column-width-130">
                      <div class="table-heading">
                        <p class="text mb-0">Document No.</p>
                      </div>
                    </th>
                    <th class="status-column">
                      <div class="table-heading">
                        <p class="text mb-0">Valid From</p>
                      </div>
                    </th>
                    <th class="status-column">
                      <div class="table-heading">
                        <p class="text mb-0">Valid To</p>
                      </div>
                    </th>
                    <th>
                      <div class="table-heading">
                        <p class="text mb-0">Upload*</p>
                      </div>
                    </th>
                    <!-- <th class="options-column">
                      <div class="table-heading border-0">
                        <p class="text mb-0">Actions</p>
                      </div>
                    </th> -->
                  </thead>
                
                  <tbody formArrayName="documents">
                    <tr *ngFor="let document of documentsArray(visaIndex).controls; let docIndex = index" [formGroupName]="docIndex">
                      <td>{{docIndex + 1}}</td>
                      <td>{{document.get('documentName')?.value}}</td>
                      <td>
                        <div class="table-input">
                          <input type="text" class="input" formControlName="documentNumber">
                        </div>
                      </td>
                      <td>
                        <div class="table-input">
                          <app-date-picker formControlName="validFrom"></app-date-picker>
                        </div>
                      </td>
                      <td>
                        <div class="table-input">
                          <app-date-picker formControlName="validTo" [minDate]="document.get('validFrom')?.value"></app-date-picker>
                        </div>
                      </td>
                      <td>
                        <div class="table-input d-flex">
                          <label [attr.for]="'visa'+visaIndex+'doc'+docIndex" class="upload-btn clickable-text"><ion-icon name="cloud-upload-outline"></ion-icon></label>
                          <div class="file-view" *ngIf="documentsArray(visaIndex).at(docIndex).get('document')?.value"><p class="clickable-text mb-0" (click)="openAttachment(documentsArray(visaIndex).at(docIndex).get('document')?.value)">View Document</p></div>
                          <input [attr.id]="'visa'+visaIndex+'doc'+docIndex" type="file" class="d-none" (change)="onDocumentSelected($event, visaIndex, docIndex)" accept="image/*,.pdf">
                        </div>
                      </td>
                    </tr>

                    <tr *ngIf="documentsArray(visaIndex)?.length === 0">
                      <td colspan="7" class="text-center">
                        <p class="my-2">No Documents Selected!</p>
                      </td>
                    </tr>
                    
                  </tbody>
                  
                </table>
              </div>

              <div class="py-1 px-2">
                <div class="d-flex">
                  <div class="passenger-input d-flex align-items-center me-3">
                    <label class="label me-1">Visa Issue Date</label>
                    <div>
                      <app-date-picker formControlName="issueDate" [maxDate]="today"></app-date-picker>
                    </div>
                  </div>
                  
                  <div class="passenger-input d-flex align-items-center me-3">
                    <label class="label me-1">Visa Expiry Date</label>
                    <div>
                      <app-date-picker formControlName="expiryDate" [isDisabled]="!visasArray().at(visaIndex).get('issueDate')?.value" [minDate]="convertToDate(visasArray().at(visaIndex).get('issueDate')?.value)"></app-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="my-2 dashed-line"></div>
          </div>
         </div>
        
      </div>

    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


